import React from 'react';
import { useToast } from '../contexts/ToastContext';

function DashboardPage() {
  const { showToast } = useToast();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-description">Welcome to the Trailio Admin Portal</p>
      </div>
      
      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-th-large"></i>
          </div>
          <div className="stat-content">
            <h3 className="stat-value">5</h3>
            <p className="stat-label">Applications</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-users"></i>
          </div>
          <div className="stat-content">
            <h3 className="stat-value">12</h3>
            <p className="stat-label">Clients</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-rocket"></i>
          </div>
          <div className="stat-content">
            <h3 className="stat-value">8</h3>
            <p className="stat-label">Deployments</p>
          </div>
        </div>
      </div>
      
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Recent Activity</h2>
        </div>
        <div className="card-body">
          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-icon">
                <i className="fas fa-plus-circle"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">New client <strong>Acme Corp</strong> was added</p>
                <p className="activity-time">2 hours ago</p>
              </div>
            </div>
            
            <div className="activity-item">
              <div className="activity-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">Application <strong>Inventory Manager</strong> was deployed</p>
                <p className="activity-time">Yesterday</p>
              </div>
            </div>
            
            <div className="activity-item">
              <div className="activity-icon">
                <i className="fas fa-cog"></i>
              </div>
              <div className="activity-content">
                <p className="activity-text">System maintenance completed</p>
                <p className="activity-time">3 days ago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage; 